var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from "react";
export function useContentRows(fields) {
    return useMemo(function () {
        return fields.map(function (field, index) { return (__assign(__assign({}, field), { _rhfId: field.id, _index: index })); });
    }, [fields]);
}
